import { POIShape } from './POIShape';
import * as THREE from 'three';
import { SceneSettingsData } from '../core/SceneSettingsData';
import { AppSettingsData } from '../core/AppSettingsData';
import { POI } from '../poi/POI';

export class TorusShape extends POIShape {

    constructor(
        poi: POI,
        sceneSettings?: SceneSettingsData,
        appSettings?: AppSettingsData
    ) {
        super(poi, sceneSettings, appSettings, {});
        
        // When the scene's geometry resolution changes, recreate the torus.
        this.sceneSettings?.geometryResolution.on(() => this.recreateGeometry());
    }

    protected override createGeometry(): THREE.BufferGeometry {
        const resolution = this.sceneSettings?.geometryResolution.value ?? 1.0;
        
        const radius = 0.35; // Main radius of the torus (fits in 1x1x1 box)
        const tube = 0.15;   // Radius of the tube (total diameter = 1.0)
        
        // Define base segment counts, then scale by resolution
        const baseRadialSegments = 16;
        const baseTubularSegments = 32;
        
        const radialSegments = Math.max(8, Math.ceil(baseRadialSegments * resolution));
        const tubularSegments = Math.max(6, Math.ceil(baseTubularSegments * resolution));

        return new THREE.TorusGeometry(radius, tube, radialSegments, tubularSegments);
    }
}